module.exports = __webpack_public_path__ + "img/dropdown.1b9cd0a8.svg";